import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { LoaderService } from '../../../shared/services/loader-service';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './spinner.scss',
})
export class Spinner {
  @Input() show: boolean = false;
  @Input() size: 'large' | 'small' = 'large';

  constructor(public loader: LoaderService) {}
}
